import { Component, Input } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { OfferLetter } from '@app/models/offer-letters/offer-letter.model';
import { CompanyDocument } from '@app/models/documents/company-document.model';

@Component({
    selector: 'app-candidate-information',
    templateUrl: './candidate-information.form.html',
})
export class CandidateInformationForm extends BaseForm {
    @Input() offerLetter: OfferLetter;
    @Input() offerLetterTemplates: CompanyDocument[];
}
